import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { SetupCode } from '@tcc-mono/vandijk/shared/data-access/models';
import { SetupCodeService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';

@Injectable({
  providedIn: 'root'
})
export class SetupCodeRepository extends CoreRepository<SetupCode> {

  public constructor(
    protected readonly _setupCodeService: SetupCodeService
  ) {
    super(
      { name: 'setupCodes' },
      _setupCodeService
    )
  }
}
